export default {"src":"/_next/static/media/goals-mobile.90ddf7e4.svg","height":238,"width":344,"blurWidth":0,"blurHeight":0};